<template>
  <section class="login hero is-fullheight">
    <div class="hero-body animate__animated animate__fadeIn slow-fade">
      <div class="container has-text-centered">
        <div class="columns is-multiline">
          <div class="column is-6 is-offset-3">
            <div class="box">
              <figure class="avatar">
                <img src="@/assets/images/logo.png" />
              </figure>
              <Form />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Form from '../components/form.vue';

export default {
  name: 'Login',
  components: {
    Form,
  },
  data() {
    return {};
  },
  computed: {},
};
</script>

<style scoped>
/* Haciendo la animación más lenta */
.slow-fade {
  animation-duration: 3s !important; /* Ajusta a tu gusto */
}
</style>
